import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "./layout/SideBar"; 
import { jwtDecode } from "jwt-decode";
import { logout, setIsLoggedIn, setUser } from "./features/auth/authSlice";
import { useEffect } from "react";
import axiosInstance from "./instance";
 
export const ProtectedRoute = ({ role }) => {
  const { isLoggedIn, token } = useSelector((state) => state.auth);
  const { menuData } = useSelector((state) => state.menu);
  const { user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

 
  axiosInstance.defaults.headers.common["Authorization"] = `${token}`;
  const isTokenExpired = (token) => {
    if (!token) return true;

    const decodedToken = token?.length && jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decodedToken?.exp < currentTime) {
      return true;
    }

    return false;
  };
  

  async function handleInit() {
		if (token?.length > 0) {
			const decoded = await jwtDecode(token);
			await dispatch(setUser(decoded));
		} else { 
			return;
		}
	}

  async function handleLogout() {  
    await dispatch(logout()); 
    await localStorage.clear();
    await dispatch(setIsLoggedIn(false));
    await navigate("/login"); 
  }
 
 
 
  useEffect(()=>{ 
    if(user?.changePassword === true || user?.changePassword === null){
      navigate('/account-settings')
    }
  },[user])

  

  useEffect(() => {
    if (isTokenExpired(token)) {
      handleLogout();
    }
  }, [token, pathname, menuData]);

  

  useEffect(()=>{ 
    handleInit();
  },[])

  
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />
  }

  return (
    <>
      
        <div className="flex items-start justify-start w-full h-[92vh]">
          <SideBar />
          <Outlet />
        </div> 
    </>
  );
};
